// -- helper functions --

/**
 * Formats a millisecond time range as a readable date interval for the export dialog.
 */
export function formatExportTimeRange(
  timeRange: readonly [number, number] | undefined,
  locale: Intl.LocalesArgument = 'fr-FR'
): string {
  if (!timeRange) {
    return '-';
  }

  const dateFormatter = new Intl.DateTimeFormat(locale, {
    dateStyle: 'short',
    timeStyle: 'medium',
  });

  const startLabel = dateFormatter.format(new Date(timeRange[0]));
  const endLabel = dateFormatter.format(new Date(timeRange[1]));

  return `${startLabel} - ${endLabel}`;
}

/**
 * Returns true when two time ranges cover the same span (within a small tolerance).
 */
export function areExportTimeRangesEqual(
  first: readonly [number, number] | undefined,
  second: readonly [number, number] | undefined,
  toleranceMs = 1000
): boolean {
  if (!first || !second) {
    return false;
  }

  return (
    Math.abs(first[0] - second[0]) <= toleranceMs &&
    Math.abs(first[1] - second[1]) <= toleranceMs
  );
}
